import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

const themes = {
  dark: 'button-dark',
  default: 'button-default',
  outline: 'button-outline',
  delete: 'button-delete',
  blue: 'button-blue',
  green: 'button-green',
  orange: 'button-orange',
  yellow: 'button-yellow',
  brown: 'button-brown',
  colorful: 'button-colorful'
}

const Button = ({
  action,
  className,
  children,
  theme = 'default',
  disabled = false,
  icon = null,
  iconSize = '18pt',
  size = 'medium',
  target = '_blank',
  ...props
}) => {
  const IconElement = icon
  const classes = `${className || ''} items-center focus:outline-none ${themes[theme]}`
  const sizeClasses =
    size == 'medium' ? 'text-sm' : size == 'xl' ? 'text-md md:text-2xl' : 'text-xs'
  const linkClasses = disabled
    ? `inline-block font-bold ${sizeClasses} text-black cursor-not-allowed opacity-50 ${classes}`
    : `inline-block font-bold ${sizeClasses} transition-colors duration-300 ease-in-out levitate ${classes}`

  const linkContent = (
    <>
      {icon && (
        <IconElement
          className={`inline-block ${children ? 'ml-4' : 'my-2 mx-4'}`}
          size={iconSize}
        />
      )}
      {children && (
        <span className={`inline-block py-3 ml-4 ${icon ? 'mr-4' : 'mr-4'}`}>
          {children}
        </span>
      )}
    </>
  )

  const clickAction = (e) => {
    e.preventDefault()
    e.stopPropagation()
    action()
  }

  const isFunction =
    typeof action === 'function' || typeof action === 'undefined'
  const isExternal = !isFunction && action.startsWith('http')

  if (disabled) {
    return (
      <span className={linkClasses} {...props}>
        {linkContent}
      </span>
    )
  } else if (isFunction) {
    return (
      <button className={linkClasses} onClick={clickAction} {...props}>
        {linkContent}
      </button>
    )
  } else if (isExternal) {
    return (
      <a
        href={action}
        className={linkClasses}
        target={target}
        rel="noreferrer nofollow"
        {...props}
      >
        {linkContent}
      </a>
    )
  } else {
    return (
      <GatsbyLink to={action} className={linkClasses} {...props}>
        {linkContent}
      </GatsbyLink>
    )
  }
}

export default Button
